import BaseService from './BaseService';

export default class TrendingService extends BaseService {
  static endpoint = 'movie/upcoming';
}
